import axios from 'axios';
import { API_URL, REVISION, UPDATE_REVISION, SHOW_REVISION, DELETE_REVISION, SHOW_NONCONFORMITY_REVISION, DELETE_REVISION_PASS } from './ConstantService';

export const RevisionService = {
  deleteWithPassword(id, password) {
    return axios.post(DELETE_REVISION_PASS.replace('{id}', id), { password });
  },

  getAllNonConformity (id) {
    return axios.get(API_URL + SHOW_NONCONFORMITY_REVISION.replace('{id}', id));
  },

  getAll(params = {}) {
    return axios.get(API_URL + REVISION, { params });
  },

  show(id) {
    return axios.get(API_URL + SHOW_REVISION.replace('{id}', id));
  },

  update(id, data) {
    return axios.patch(API_URL + UPDATE_REVISION.replace('{id}', id), data);
  },

  delete(id) {
    return axios.delete(API_URL + DELETE_REVISION.replace('{id}', id));
  },

  create(data) {
    return axios.post(API_URL + REVISION, data);
  }
};
